import { render, staticRenderFns } from "./HeroSpace.vue?vue&type=template&id=2fc3f4d3&scoped=true"
import script from "./HeroSpace.vue?vue&type=script&lang=js"
export * from "./HeroSpace.vue?vue&type=script&lang=js"
import style0 from "./HeroSpace.vue?vue&type=style&index=0&id=2fc3f4d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3f4d3",
  null
  
)

export default component.exports